<template>

  <div class="ads-left-bar mdl-card mdl-shadow--2dp">
    <div class="mdl-card__title mdl-color--primary">
      <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent bar_button"
              @click="toggleQueryExpand">
        <i class="material-icons" v-if="queryExpand">expand_less</i>
        <i class="material-icons" v-if="!queryExpand">expand_more</i>
      </button>
      <h2 class="mdl-card__title-text">{{ i18n().title }}</h2>

      <div class="bar-controls">
        <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent"
                @click="$emit('save')"><i class="material-icons">save</i></button>
        <button class="mdl-button mdl-js-button mdl-button--fab mdl-button--raised mdl-button--accent"
                @click="$emit('load')"><i class="material-icons">file_upload</i></button>
      </div>

    </div>
    <div class="mdl-card__supporting-text query-panel" v-show="queryExpand">
      <AdsQuery :categories="categories"
                  :query="query" @update:query="handleQueryUpdate"></AdsQuery>

      <div>
        <Checkbox :checked="enableFilter" @update:checked="handleEnableFilterUpdate" :label="i18n().filterResults"></Checkbox>
      </div>
    </div>

   <!-- <div class="mdl-card__title mdl-color&#45;&#45;primary" v-if="enableFilter">

      <button class="mdl-button mdl-js-button mdl-button&#45;&#45;fab mdl-button&#45;&#45;raised mdl-button&#45;&#45;accent bar_button"
              @click="toggleFilterExpand" v-if="false">
        <i class="material-icons" v-if="filterExpand">expand_less</i>
        <i class="material-icons" v-if="!filterExpand">expand_more</i>
      </button>

      <h2 class="mdl-card__title-text">Filter</h2>
      <div v-if="!appliedFilter" class="bar-controls">
        <button class="mdl-button mdl-js-button mdl-button&#45;&#45;fab mdl-button&#45;&#45;raised mdl-button&#45;&#45;accent"
                @click="$emit('applyFilter')"><i class="material-icons">check</i></button>
      </div>
      <div v-if="appliedFilter" class="bar-controls">
        <button class="mdl-button mdl-js-button mdl-button&#45;&#45;fab mdl-button&#45;&#45;raised mdl-button&#45;&#45;accent"
                @click="$emit('updateFilter')"><i class="material-icons">refresh</i></button>
        <button class="mdl-button mdl-js-button mdl-button&#45;&#45;fab mdl-button&#45;&#45;raised mdl-button&#45;&#45;accent"
                @click="$emit('clearFilter')"><i class="material-icons">clear</i></button>
      </div>

    </div>
    <div class="mdl-card__supporting-text mdl-card&#45;&#45;expand filter-holder" v-if="enableFilter && calculatedColumnNames"
         v-show="filterExpand">
      <SimpleFilterExpression :expression="filter" @update:expression="handleFilterUpdate"
                              :columns="calculatedColumnNames"></SimpleFilterExpression>
      &lt;!&ndash;<pre>{{ JSON.stringify(filter, null, "  ") }}</pre>&ndash;&gt;
    </div>-->
  </div>

</template>

<script>

  import FilterExpression from "../query/FilterExpression"
  import SimpleFilterExpression from "../query/SimpleFilterExpression"
  import AdsQuery from "../ads/AdsQuery.vue"
  import Checkbox from "../utils/Checkbox.vue"
  import config from "../../config"
  import i18n from "i18n"

  export default {
    name: "words-left-bar",
    props: {
      query: {
        type: Object
      },
      filter: {
        type: Object
      },
      appliedFilter: {
        type: Object
      },
      inputColumnNames: {
        type: Array
      },
      calculatedColumnNames: {
        type: Array
      },
      categories: {
        type: Array
      },
      enableFilter: {
        type: Boolean
      }
    },
    components: {
      FilterExpression,
      SimpleFilterExpression,
      AdsQuery,
      Checkbox
    },
    enableFilter: {
      type: Boolean
    },
    data() {
      return {
        queryExpand : true,
        filterExpand : true
      }
    },
    computed: {
    },
    methods: {
      i18n() {
        return i18n().ads.query
      },
      toggleQueryExpand() {
        this.queryExpand = !this.queryExpand
      },
      toggleFilterExpand() {
        this.filterExpand = !this.filterExpand
      },
      handleFilterUpdate(f) {
        this.$emit("update:filter", f)
      },
      handleQueryUpdate(q) {
        this.$emit("update:query", q)
      },
      handleEnableFilterUpdate(v) {
        this.$emit("update:enableFilter", v)
      }
    }
  }

</script>

<style scoped>

  .ads-left-bar {
    position: absolute;
    left: 0em;
    top: 0em;
    bottom: 1em;
    width: 14em;
    height: auto;
  }
  .ads-left-bar .mdl-card__title {
    flex-shrink: 0;
  }
  .ads-left-bar .query-panel {
    flex-shrink: 0;
  }
  .ads-left-bar .query-panel > div {
    margin-right: 1em;
  }

  .filter-holder {
    width: auto;
    overflow-y: auto;
    padding: 0;
  }

  .bar-controls {
    margin: 0 0 0 5px;
  }
  .bar-controls:nth-child(1) {
    margin-left: 10px;
  }

  .bar-controls > button {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: 0px;
  }
  .bar-controls > button > i {
    font-size: 20px;
  }

  .mdl-button.bar_button {
    width: 28px;
    max-width: 28px;
    min-width: 28px;
    height: 28px;
    margin-left: -10px;
    margin-right: 8px;
  }
  .mdl-button.bar_button > i {
    font-size: 20px;
  }
</style>



// WEBPACK FOOTER //
// AdsLeftBar.vue?8f6b9eb2